module.exports = __webpack_public_path__ + "static/media/attack.141b9ebb.png";